import { Component, ChangeDetectionStrategy, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DatalinkReadCollectionDto } from '../../../core/dto/datalink-read-collection';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { dasherize } from '../../../utils/strings';
import { Observable } from 'rxjs';
import { MetadataService } from '../../../core/services/metadata.service';
import { DataLinksResourceService } from '../../../core/api/data-links-resource.service';
import { pluck } from 'rxjs/operators';

@Component({
    selector: 'isav-data-links-landing-page',
    templateUrl: './data-links-landing-page.html',
    styleUrls: ['./data-links-landing-page.sass'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DataLinksLandingPage implements OnInit {
    searchForm = new UntypedFormGroup({
        text: new UntypedFormControl(null, [Validators.required]),
    });

    newestDataLinks$: Observable<DatalinkReadCollectionDto[]>;
    randomDataLinks$: Observable<DatalinkReadCollectionDto[]>;

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private metaService: MetadataService,
        private datalinksService: DataLinksResourceService
    ) {}

    ngOnInit(): void {
        this.metaService.setTitle('Data-Links');

        this.newestDataLinks$ = this.datalinksService
            .getAll({
                'order[createdAt]': 'desc',
                itemsPerPage: '4',
            })
            .pipe(pluck('member'));

        this.randomDataLinks$ = this.datalinksService
            .getAll({
                random: 'true',
                itemsPerPage: '12',
            })
            .pipe(pluck('member'));
    }

    search() {
        this.router.navigate(['search'], {
            relativeTo: this.route,
            queryParams: this.searchForm.value,
        });
    }

    linkTo(datalink: DatalinkReadCollectionDto) {
        return ['view', dasherize(datalink.fullNameOfDataSet || '')];
    }
}
